(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/shared-components/input/cell-phone-input.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/shared-components/input/cell-phone-input.js');
"use strict";


const MobileInput = svs.ui.reactFormInputs.MobileInput;
const CELL_PHONE = svs.ticket_partner.sharedComponents.input.constants.names.CELL_PHONE;
const _svs$ticket_partner$s = svs.ticket_partner.sharedComponents.input.constants.TEXTS.CELL_PHONE_NUMBER,
  LABEL = _svs$ticket_partner$s.LABEL,
  REQUIRED_ERROR = _svs$ticket_partner$s.REQUIRED_ERROR;
const CellPhoneNrInput = _ref => {
  let handleChange = _ref.handleChange,
    state = _ref.state,
    _ref$isLessSpace = _ref.isLessSpace,
    isLessSpace = _ref$isLessSpace === void 0 ? false : _ref$isLessSpace;
  return React.createElement(MobileInput, {
    errorMessageRequired: REQUIRED_ERROR,
    id: CELL_PHONE,
    isLessSpace: isLessSpace,
    isRequired: true,
    label: LABEL,
    name: CELL_PHONE,
    onChange: handleChange,
    value: state[CELL_PHONE]
  });
};
svs.ticket_partner.sharedComponents.input.CellPhoneNrInput = CellPhoneNrInput;

 })(window);